import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { PlanName } from '../../types/usage.types';
import './ConversationLimitModal.css';

interface ConversationLimitModalProps {
  show: boolean;
  onHide: () => void;
  planName: PlanName;
}

const ConversationLimitModal: React.FC<ConversationLimitModalProps> = ({
  show,
  onHide,
  planName,
}) => {
  const navigate = useNavigate();
  const isUltraPlan = planName === 'ultra';

  const handleUpgrade = () => {
    onHide();
    navigate('/select-plan');
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="conversation-limit-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <ExclamationTriangleFill className="warning-icon" />
          <span>Conversation Limit Reached</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You've reached your conversation limit for this plan.
          {!isUltraPlan && ' Upgrade your plan to start a new conversation.'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        {!isUltraPlan && (
          <Button
            variant="link"
            onClick={onHide}
            className="cancel-btn"
          >
            CANCEL
          </Button>
        )}
        <Button
          variant="warning"
          onClick={isUltraPlan ? onHide : handleUpgrade}
          className="action-btn"
        >
          {isUltraPlan ? 'OK' : 'Upgrade Plan'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConversationLimitModal;
